import { TGetLookups } from '@/types/lookup';

import { configService } from '@/api/private';

export const getLookupData: TGetLookups = (params, signal) =>
  configService.get(`/lookups`, { params, signal });
